var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/camelcase */
import { INITIAL_CREDROW } from '@card/types';
import { CardApiClient } from './cardApiClient';
import { CredentialUtils } from '../utils/credentialUtils';
import { serializeParams } from '../utils/queryStringUtils';
var credentialUrls = {
    getCredentials: '/v2/credentials',
    createCredentials: '/v2/credentials',
    blockedCredentialsCount: '/v2/credentials/blocked_credentials',
    validateCredential: '/v1/credentials/validate',
    mercadopagoLink: '/v1/credentials/mercadopago_link',
    getPassword: function (id) { return "/v1/credentials/" + id + "/password"; },
    editCredential: function (id) { return "/v1/credentials/" + id; },
    enableAutomaticRenewal: function (id) { return "/v2/credentials/" + id + "/enable_automatic_renewal"; },
    disableAutomaticRenewal: function (id) { return "/v2/credentials/" + id + "/disable_automatic_renewal"; },
    setStatus: function (id) { return "/v1/credentials/" + id + "/set_status"; }
};
var usersUrls = {
    enableAutomaticRenewal: '/v2/users/enable_automatic_renewal',
    disableAutomaticRenewal: '/v2/users/disable_automatic_renewal'
};
export function getCredentials(_a) {
    var _b = _a === void 0 ? {} : _a, page = _b.page, per_page = _b.per_page, _c = _b.filters, filters = _c === void 0 ? {} : _c;
    var queryString = serializeParams(__assign({ page: page, per_page: per_page }, filters));
    return CardApiClient.get(credentialUrls.getCredentials + "?" + queryString).then(function (response) { return response.data; });
}
export function createCredential(credential) {
    return CardApiClient.post(credentialUrls.createCredentials, credential).then(function (response) { return response.data; });
}
export function validateCredential(params) {
    return CardApiClient.post(credentialUrls.validateCredential, params).then(function () {
        return createCredential(params);
    });
}
export function editCredential(_a) {
    var newPassword = _a.newPassword, idCredential = _a.idCredential;
    return CardApiClient.patch(credentialUrls.editCredential(idCredential), {
        password: newPassword
    });
}
export function getPassword(id) {
    return CardApiClient.get(credentialUrls.getPassword(id)).then(function (response) { return response.data.password; });
}
export function enableAutomaticRenewal(id) {
    return CardApiClient.post(credentialUrls.enableAutomaticRenewal(id));
}
export function disableAutomaticRenewal(id) {
    return CardApiClient.post(credentialUrls.disableAutomaticRenewal(id));
}
export function deleteCredential(id) {
    return CardApiClient.post(credentialUrls.setStatus(id), { status: 'deleted' });
}
export function userEnableAutomaticRenewal() {
    return CardApiClient.post(usersUrls.enableAutomaticRenewal);
}
export function userDisableAutomaticRenewal() {
    return CardApiClient.post(usersUrls.disableAutomaticRenewal);
}
export function userCredentials() {
    return __awaiter(this, void 0, void 0, function () {
        var credsFromAPI, credRows;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCredentials()];
                case 1:
                    credsFromAPI = _a.sent();
                    if (!credsFromAPI) {
                        credRows = [];
                        credRows.push(INITIAL_CREDROW);
                        return [2 /*return*/, credRows];
                    }
                    return [2 /*return*/, credsFromAPI.data
                            .filter(function (cred) { return ['deleted', 'disabled'].includes(cred.status) === false; })
                            .map(function (cred) { return CredentialUtils.toCredentialsRow(cred); })];
            }
        });
    });
}
export function getMercadoPagoLink() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, CardApiClient.get(credentialUrls.mercadopagoLink)];
        });
    });
}
export function getBlockedCount() {
    return CardApiClient.get(credentialUrls.blockedCredentialsCount).then(function (response) { return response.data; });
}
